import { render, staticRenderFns } from "./user_course_comment.vue?vue&type=template&id=6b41028f&scoped=true"
import script from "./user_course_comment.vue?vue&type=script&lang=js"
export * from "./user_course_comment.vue?vue&type=script&lang=js"
import style0 from "./user_course_comment.css?vue&type=style&index=0&id=6b41028f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b41028f",
  null
  
)

export default component.exports